// Action Types
import * as actionTypes from './actionTypes';

// Actions
import { retrieveDealerData } from 'store/reducers/dealerData/actions';
import { deeplinkInit } from 'store/reducers/deeplink/actions';

// Selectors
import { getTokenId } from 'store/reducers/tokenId/selectors';

// Utils
import { isFn } from 'utils/varValidation';

export const initData = (data, isConsumer8) => async (dispatch, getState) => {
  if (!getTokenId(getState())) {
    await dispatch(retrieveDealerData(data));
    isConsumer8 && dispatch(deeplinkInit());
  }
};

export const ajaxCallbacks = (config = {}) => dispatch => {
  return {
    request: request => {
      if (isFn(config.requestCallback)) {
        config.requestCallback(request);
      }
      dispatch(requestCallback(request));
    },
    response: response => {
      if (isFn(config.responseCallback)) {
        config.responseCallback(response);
      }
      dispatch(responseCallback(response));
    }
  };
};

const requestCallback = (service, config) => dispatch => {
  dispatch(addToStackAjax(service));
  // dispatch(addToBinnacle(service));
};

const responseCallback = (service, response) => dispatch => {
  dispatch(removeFromStackAjax(service.getId()));
};

const addToStackAjax = service => {
  return {
    type: actionTypes.ADD_TO_STACK_AJAX,
    payload: service
  };
};

const removeFromStackAjax = serviceId => {
  return {
    type: actionTypes.REMOVE_FROM_STACK_AJAX,
    payload: serviceId
  };
};



// WEBPACK FOOTER //
// ./src/store/reducers/ajaxCall/actions.js